module.exports = __webpack_public_path__ + "static/ridge-wayne-light-25143905808e0aeba467a409c2baa36d.png";